import { graphql } from "~/gql";

export const UPDATE_USER_SETTINGS = graphql(/* GraphQL */ `
  mutation UpdateUserSettings($data: UserSettingsUpdateInput!) {
    updateUserSettings(data: $data) {
      darkTheme
      customPaletteHex
    }
  }
`);
